import { useCallback, useContext, useEffect, useMemo, useState } from "react";

import { Box } from "@mui/material";
import DossierHeader, { headerInfosType } from "./Headers/DossierHeader";
import "../../components-styles.scss";
import "./dossier-styles.scss";
import Commitements from "./Commitments/Commitements";
import Audit from "./Audit/Audit";
import {
    DossierDataToUpdate,
    DossierStatusEnum,
    EstablishmentCategory,
    EstablishmentStatus,
    RolesEnum,
    Session,
    TabMenu,
    establishementStatusEnum,
} from "../../../types";
import { CustomModalContext, LayoutBarContext } from "../../../contexts";
import {
    deleteDossier,
    dossiersAssignment,
    getEstablishmentStatus,
    updateDossier,
    uploadContractService,
} from "../../../services";
import Dossiers from "../Dossiers";
import DeleteDossierModalContent from "./Delete/DeleteDossierModalContent";
import SucessDeleteDossierContent from "./Delete/SucessDeleteDossierContent";
import { useDossier } from "../useDossier";
import {
    _downloadContract,
    downloadZip,
    generateContract,
    groupBy,
    scrollToTop,
} from "../../../helpers";
import Footer, { FooterProps } from "../../Footer/Footer";
import {
    daysBeforeDeadlineKey,
    dossierStorageKey,
    processingStepThresholdKey,
    sessionStorageKey,
    settingStorageKey,
} from "../../../consts";
import { useFetch, useLocalStorage } from "../../../hooks";
import {
    buildInstructionInfos,
    canShowDownloadCertificateBtn,
    getTabsMenuByUserRole,
} from "./utils";
import EstablishmentInfosView from "../../Profil/Client/EstablishemntInfos/EstablishmentInfosView";
import { getDossierStatusByCode, getEstablishmentStatusByCode } from "../utils";
import {
    NowDateTime,
    addDays,
    formatDate,
    dateFormatMoment,
} from "../../../lib";
import { backOrForwardDossier } from "./Commitments/Commitment/SubmitDossier/SubmitDossierInstructor";
import {
    getInstructorAssignedOfDossier,
    getInstructorReview,
    getValidatorDecision,
    sendedToValidate,
    wattingForAssigned,
} from "./OverViews/utils";
import SendDossierToSynerpaModalContent from "../Dossier/Submit/SubmitToSynerpaModalContent";
import SendDossierToClientModalContent from "../Dossier/Submit/SubmitBackToClientModalContent";
import SucessSubmitDossierContent from "./Commitments/Commitment/SubmitDossier/SubmitDossierSuccesModalContent";
import DecisionFinalModalContent from "./Submit/DecisionFInalModalContent";
import SucessSubmitDossierToInstructionContent from "./Submit/SucessSubmitDossierToInstructionContent";
import SubmitDialogClient from "./Submit/SubmitDialogClient";
import FailResponseModalContent from "./Submit/FailureFromBackModalContent";
import ContractManagerModalContent from "./Contract/ContractManagerModalContent";
import { ConstructionOutlined } from "@mui/icons-material";
/**
 *
 * input : on aura un dossierId, et on obtient dossierDetails
 */

export type DossierInfosType = {
    id: number | null;
    year: number | undefined;
    establishmentType: string | undefined;
    isResendToInstruct: boolean;
    currentDossierStatusId: number;
    currentAssignedUserId: number | null;
};

type DossierProps = {
    dossierId: number;
};

export default function Dossier({ dossierId }: DossierProps) {
    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser, currentUserRoleId: userRoleId },
        [settingStorageKey]: [...settings],
        [dossierStorageKey]: { dossierStatus, establishmentStatus },
    } = session;

    const daysBeforeDeadline = Number(
        (settings.find((s) => s.key === daysBeforeDeadlineKey) || {}).value
    );
    const processingStepThreshold = Number(
        (settings.find((s) => s.key === processingStepThresholdKey) || {}).value
    );

    const tabsMenu: TabMenu[] = getTabsMenuByUserRole(userRoleId);

    const [activeTab, setActiveTab] = useState<string>(tabsMenu[0].key);

    const { updateContent } = useContext(LayoutBarContext);

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { fetcher } = useFetch();

    const {
        fetchDossierDetail,
        dossierDetails,
        linearProgressValue,
        establishment,
        instructorList,
        assignedValidatorUser,
        downloadCertificate,
        regionList,
        fetchRegionList,
        establishmentGroups,
    } = useDossier();
    const [disabled, setDisabled] = useState(false);
    const contractSignedUrl = dossierDetails?.contractUrl;

    const disabledFooterBtn =
        linearProgressValue !== 100 || disabled || !contractSignedUrl;

    const [isPayed, setIsPayed] = useState<boolean>(
        dossierDetails?.payment ? dossierDetails?.payment : false
    );

    const soumisStatus = (
        getDossierStatusByCode(DossierStatusEnum.SOUMIS, dossierStatus) || {}
    ).id;

    const isResendToInstruct = dossierDetails
        ? dossierDetails.processingStep >= processingStepThreshold
        : false;

    const canShowDeleteBtn =
        userRoleId === RolesEnum.CLIENT &&
        !dossierDetails?.assignedUser &&
        soumisStatus !== dossierDetails?.dossierStatus.id;

    const [establishmentStatuses, setEstablishmentStatuses] = useState([]);

    // ############################### Header #######################

    const headerInfos = useMemo(() => {
        const validatorDecision = dossierDetails
            ? getValidatorDecision(dossierDetails, establishmentStatus)
            : null;

        let _headerInfos: headerInfosType = {
            dossierStatut: dossierDetails?.dossierStatus.label ?? "",
            referencielName: dossierDetails?.referenciel.name ?? "",
            dossierId: dossierDetails?.id ?? null,
            dossierDetails: dossierDetails,
            isResendToInstruct,
            establishmentName: establishment?.companyName ?? "",
        };

        if (validatorDecision) {
            _headerInfos.validatorDecision = validatorDecision;
        }

        if (
            [
                RolesEnum.INSTRUCTEUR,
                RolesEnum.ADMIN,
                RolesEnum.SYNERPA,
            ].includes(userRoleId)
        ) {
            if (dossierDetails) {
                const { instructionInfos } = buildInstructionInfos(
                    dossierDetails,
                    daysBeforeDeadline
                );

                const isSendendToValidate = sendedToValidate(dossierDetails);

                _headerInfos = {
                    ..._headerInfos,
                    instructionInfos,
                    processingStepThreshold,
                };

                if (
                    isSendendToValidate ||
                    dossierDetails.dossierStatus.code ===
                        DossierStatusEnum.FINALISE
                ) {
                    const instructorReview =
                        getInstructorReview(dossierDetails);

                    _headerInfos.instructorReview = instructorReview;
                }
                if (userRoleId === RolesEnum.ADMIN) {
                    const instructorAssignedOfDossier =
                        getInstructorAssignedOfDossier(dossierDetails);
                    const isWattingForAssigned =
                        wattingForAssigned(dossierDetails);
                    if (instructorAssignedOfDossier || isWattingForAssigned) {
                        _headerInfos.instructorList = instructorList;
                    }
                    _headerInfos.assignedUser = dossierDetails.assignedUser;
                    _headerInfos.submittedAt =
                        dossierDetails?.submittedAt ?? "";
                }

                if (userRoleId === RolesEnum.SYNERPA) {
                    _headerInfos.assignedComment =
                        dossierDetails.assignedComment;
                    _headerInfos.assignedValidatorComment =
                        dossierDetails.assignedValidatorComment;
                    _headerInfos.assignedValidatorUser = assignedValidatorUser;
                }
            }
        }
        return _headerInfos;
    }, [dossierDetails, instructorList]);

    // #################### footer start ####################
    const sendToNextPerson = useCallback(
        async (dossierDataToUpdate: DossierDataToUpdate) => {
            if (dossierDetails?.id) {
                const statusToSynerpa = (
                    getDossierStatusByCode(
                        DossierStatusEnum.ATTENTE_DECISION,
                        dossierStatus
                    ) || {}
                ).id;
                const statusToBeSubmitted = (
                    getDossierStatusByCode(
                        DossierStatusEnum.CREATION,
                        dossierStatus
                    ) || {}
                ).id;
                if (dossierDataToUpdate.dossierStatus !== statusToSynerpa) {
                    const now = NowDateTime();
                    dossierDataToUpdate.processedAt = now;
                    dossierDataToUpdate.completionTime = formatDate(
                        addDays(now, daysBeforeDeadline).toString(),
                        dateFormatMoment
                    );
                    // add avis ######
                }
                if (
                    dossierDataToUpdate.dossierStatus == statusToBeSubmitted &&
                    dossierDetails.creatorUser != null
                ) {
                    dossierDataToUpdate.submittedUser = session.auth.userAdmin
                        ? session.auth.userAdmin.id
                        : currentUser.id;
                }

                const updatingtingDossierRes = await updateDossier(
                    dossierDetails.id,
                    dossierDataToUpdate
                );
                if (!updatingtingDossierRes.detail) {
                    updateModal({
                        content: (
                            <SucessSubmitDossierContent
                                onSucessSubmitDossier={async () => {
                                    updateContent(<Dossiers />);
                                    updateIsCustomModalActive(false);
                                }}
                            />
                        ),
                        title: "",
                    });
                }
            }
        },
        [dossierDetails]
    );

    const getAllEstablishementStatuses = async () => {
        const fetchEstablishementStatuses = await getEstablishmentStatus();
        if (!fetchEstablishementStatuses.detail) {
            setEstablishmentStatuses(fetchEstablishementStatuses);
        }
    };

    const decisionMade = useCallback(
        async (dossierDataToUpdate: DossierDataToUpdate) => {
            if (dossierDetails?.id) {
                dossierDataToUpdate.assignedValidatorDecisionAt = NowDateTime();
                const updatingtingDossierRes = await updateDossier(
                    //TODO ajouter date de décision quand le champ existera.
                    dossierDetails.id,
                    dossierDataToUpdate
                );
                if (!updatingtingDossierRes.detail) {
                    updateModal({
                        content: (
                            <SucessSubmitDossierContent
                                onSucessSubmitDossier={async () => {
                                    updateContent(<Dossiers />);
                                    updateIsCustomModalActive(false);
                                }}
                            />
                        ),
                        title: "",
                    });
                }
            }
        },
        [dossierDetails]
    );

    const handleSubmitUpdateDossier = async (
        dossierDataToUpdate: DossierDataToUpdate
    ) => {
        if (dossierDetails?.id) {
            const updatingDossierRes = await updateDossier(
                dossierDetails.id,
                dossierDataToUpdate
            );
            if (!updatingDossierRes.detail) {
                updateModal({
                    content: (
                        <SucessSubmitDossierToInstructionContent
                            onSucessSubmitDossierToInstruction={() => {
                                updateContent(<Dossiers />);
                                updateIsCustomModalActive(false);
                            }}
                        />
                    ),
                    title: "",
                });
                updateIsCustomModalActive(true);
            } else {
                updateModal({
                    content: (
                        <FailResponseModalContent
                            error={updatingDossierRes.detail}
                            onCloseModale={() => {
                                updateContent(<Dossiers />);
                                updateIsCustomModalActive(false);
                            }}
                        />
                    ),
                    title: "",
                });
                updateIsCustomModalActive(true);
            }
        }
    };

    const handleAssignValidatorUser = useCallback(async () => {
        if (dossierDetails?.id) {
            const updatingDossierRes = await updateDossier(dossierDetails.id, {
                assignedValidatorUser: currentUser.id,
            });
            if (!updatingDossierRes.detail) {
                await fetchDossierDetail(dossierId);
            }
        }
    }, [dossierDetails]);

    const affectOrdecision = (affected: boolean) => {
        if (!affected) {
            return {
                onClick: async () => {
                    await handleAssignValidatorUser();
                },
                label: "Je prends en charge l’examen",
            };
        }

        // if(dossierDetails?.establishmentStatus && estaIdStatusesDone.map((status: EstablishmentStatus | undefined) => { return status?.id}).includes(dossierDetails?.establishmentStatus)){
        //     return {
        //         label: "Décision déjà rendue",
        //         disabledBtn: true,
        //     };
        // }
        const attenteDecisionId = (
            getEstablishmentStatusByCode(
                establishementStatusEnum.CANDIDAT,
                establishmentStatuses
            ) || {}
        ).id;
        const isFirstDecision =
            null == dossierDetails?.establishmentStatus ||
            dossierDetails.establishmentStatus === attenteDecisionId;

        return {
            label: isFirstDecision
                ? "Rendre une décision"
                : "Rendre une nouvelle décision",
            onClick: async () => {
                await getAllEstablishementStatuses();

                if (
                    null != dossierDetails &&
                    establishmentStatuses.length > 0
                ) {
                    const isSuspended =
                        (
                            getEstablishmentStatusByCode(
                                establishementStatusEnum.SUSPENDU,
                                establishmentStatuses
                            ) || {}
                        ).id === dossierDetails.establishmentStatus;
                    const statusFinal = (
                        getDossierStatusByCode(
                            DossierStatusEnum.FINALISE,
                            dossierStatus
                        ) || {}
                    ).id;
                    const dossierDataToUpdate: DossierDataToUpdate = {
                        dossierStatus: statusFinal,
                        establishmentStatus: null,
                    };
                    const statusFirstCode = (
                        getEstablishmentStatusByCode(
                            isFirstDecision
                                ? establishementStatusEnum.QUALIFIE
                                : isSuspended
                                ? establishementStatusEnum.QUALIFIE
                                : establishementStatusEnum.SUSPENDU,
                            establishmentStatus
                        ) || {}
                    ).id;
                    const statusSecondeCode = (
                        getEstablishmentStatusByCode(
                            isFirstDecision
                                ? establishementStatusEnum.NON_QUALIFIE
                                : isSuspended
                                ? establishementStatusEnum.ANNULE
                                : establishementStatusEnum.RETIRE,
                            establishmentStatuses
                        ) || {}
                    ).id;
                    const instructorReview = dossierDetails
                        ? getInstructorReview(dossierDetails)
                        : "";

                    const textSynerpa = isFirstDecision
                        ? `L'instructeur SOCOTEC a émis un avis ${instructorReview}`
                        : `Cet établissement est actuellement ${
                              isSuspended ? "suspendu" : "certifié"
                          } par SYNERPA`;
                    const labelfR = isFirstDecision
                        ? "Etablissement qualifié"
                        : isSuspended
                        ? "Rétablir la certification"
                        : "Suspendre la certification";
                    const labelsR = isFirstDecision
                        ? "Qualification refusée"
                        : isSuspended
                        ? "Annuler la certification"
                        : "Retirer la certification";
                    const contentModal = (
                        <DecisionFinalModalContent
                            firstDecision={isFirstDecision}
                            suspended={establishmentStatus}
                            statusFirstId={statusFirstCode}
                            statusSecondeId={statusSecondeCode}
                            labelFirstRadio={labelfR}
                            labelSecondRadio={labelsR}
                            text={textSynerpa}
                            dataDossier={dossierDataToUpdate}
                            onSubmit={decisionMade}
                        />
                    );

                    //updateModal with vars
                    updateModal({
                        content: contentModal,
                        title: "",
                    });
                    updateIsCustomModalActive(true);
                }
            },
        };
    };

    const getFooterPropsByUserRole = (userRoleId: number): FooterProps => {
        switch (userRoleId) {
            case RolesEnum.ADMIN_RESEAU:
            case RolesEnum.ADMIN_REGION:
            case RolesEnum.CLIENT:
                const soumisStatus = (
                    getDossierStatusByCode(
                        DossierStatusEnum.SOUMIS,
                        dossierStatus
                    ) || {}
                ).id;

                const inProgressInstructionStatus = (
                    getDossierStatusByCode(
                        DossierStatusEnum.EN_COURS_D_INSTRUCTION,
                        dossierStatus
                    ) || {}
                ).id;

                let dossierDataToUpdate: DossierDataToUpdate = {
                    dossierStatus: soumisStatus,
                    submittedAt: NowDateTime(),
                    submittedUser: session.auth.userAdmin
                        ? session.auth.userAdmin.id
                        : null,
                };

                if (dossierDetails?.assignedUser) {
                    dossierDataToUpdate.dossierStatus =
                        inProgressInstructionStatus;
                }
                const validationSuccess = async () => {
                    const doSubmit = async () => {
                        setDisabled(true);
                        await handleSubmitUpdateDossier(dossierDataToUpdate);
                    };
                    fetcher(doSubmit());
                };
                return {
                    onClick: () => {
                        updateModal({
                            content: (
                                <SubmitDialogClient
                                    onAcceptSubmitDossierToInstruction={
                                        validationSuccess
                                    }
                                    hideModal={updateIsCustomModalActive}
                                />
                            ),
                            title: "",
                        });
                        updateIsCustomModalActive(true);
                    },
                    label: "Soumettre mon dossier",
                };
            case RolesEnum.ADMIN:
            case RolesEnum.INSTRUCTEUR:
                let backOrForward = false;
                let isDeadlineExceeded = false;

                if (dossierDetails) {
                    backOrForward = backOrForwardDossier(
                        dossierDetails.referenciel.commitments
                    );
                    const { remainingNbDaysToInstruct } = buildInstructionInfos(
                        dossierDetails,
                        daysBeforeDeadline
                    );
                    isDeadlineExceeded = remainingNbDaysToInstruct <= 0;
                }
                const stepsOk =
                    dossierDetails &&
                    dossierDetails?.processingStep <= processingStepThreshold;

                const labelFooter =
                    backOrForward || stepsOk || isDeadlineExceeded
                        ? "Soumettre un avis"
                        : "Retour au client";
                return {
                    label: labelFooter,
                    onClick: async () => {
                        if (null != dossierDetails) {
                            const statusToSynerpa = (
                                getDossierStatusByCode(
                                    DossierStatusEnum.ATTENTE_DECISION,
                                    dossierStatus
                                ) || {}
                            ).id;
                            const dossierDataToUpdate: DossierDataToUpdate = {
                                dossierStatus: statusToSynerpa,
                                processedAt: NowDateTime(),
                            };
                            let contentModal = (
                                <SendDossierToSynerpaModalContent
                                    stepsOk={backOrForward}
                                    dataDossier={dossierDataToUpdate}
                                    onSubmit={sendToNextPerson}
                                    defaultOpinionValue={backOrForward}
                                />
                            );

                            if (
                                dossierDetails.processingStep <
                                    processingStepThreshold &&
                                !backOrForward
                            ) {
                                const statusBackToClient = (
                                    getDossierStatusByCode(
                                        DossierStatusEnum.CREATION,
                                        dossierStatus
                                    ) || {}
                                ).id;
                                dossierDataToUpdate.dossierStatus =
                                    statusBackToClient;
                                dossierDataToUpdate.processingStep =
                                    dossierDetails.processingStep + 1;
                                contentModal = (
                                    <SendDossierToClientModalContent
                                        dataDossier={dossierDataToUpdate}
                                        onSubmit={sendToNextPerson}
                                    />
                                );
                            }

                            //updateModal with vars
                            updateModal({
                                content: contentModal,
                                title: "",
                            });
                            updateIsCustomModalActive(true);
                        }
                    },
                };

            case RolesEnum.SYNERPA:
                return affectOrdecision(
                    null !== dossierDetails?.assignedValidatorUser
                );
            default: {
                return { onClick: () => {}, label: "" };
            }
        }
    };

    const synerpaUserHasNotDossierToExamine =
        !dossierDetails?.assignedValidatorUser;

    const isShowFooterByUserRole = (userRoleId: number) => {
        if (userRoleId === RolesEnum.CLIENT) {
            return (
                (
                    getDossierStatusByCode(
                        DossierStatusEnum.CREATION,
                        dossierStatus
                    ) || {}
                ).id === dossierDetails?.dossierStatus.id
            );
        }

        if ([RolesEnum.INSTRUCTEUR, RolesEnum.ADMIN].includes(userRoleId)) {
            const instructeurAllowedStatusToShowFooter = [
                DossierStatusEnum.AFFECTE,
                DossierStatusEnum.EN_COURS_D_INSTRUCTION,
            ];
            return instructeurAllowedStatusToShowFooter
                .map((s) => (getDossierStatusByCode(s, dossierStatus) || {}).id)
                .includes(dossierDetails?.dossierStatus.id);
        }

        if (RolesEnum.SYNERPA === userRoleId) {
            // check if assignedValidatorUser
            if (synerpaUserHasNotDossierToExamine) {
                return true;
            }
            const isNotHisDossier =
                dossierDetails?.assignedValidatorUser &&
                dossierDetails?.assignedValidatorUser.id !== currentUser.id;
            const estaIdStatusesDone = [
                getEstablishmentStatusByCode(
                    establishementStatusEnum.NON_QUALIFIE,
                    establishmentStatuses
                ),
                getEstablishmentStatusByCode(
                    establishementStatusEnum.ANNULE,
                    establishmentStatuses
                ),
                getEstablishmentStatusByCode(
                    establishementStatusEnum.RETIRE,
                    establishmentStatuses
                ),
            ];
            const dossierIsDone =
                dossierDetails?.establishmentStatus &&
                estaIdStatusesDone
                    .map((status: EstablishmentStatus | undefined) => {
                        return status?.id;
                    })
                    .includes(dossierDetails.establishmentStatus);
            return isNotHisDossier && !dossierIsDone;
        }

        return false;
    };

    const checkedIfAssignedToIt = useCallback(() => {
        if ([RolesEnum.ADMIN, RolesEnum.INSTRUCTEUR].includes(userRoleId)) {
            return currentUser.id === dossierDetails?.assignedUser;
        }

        return true;
    }, [dossierDetails]);

    const showFooter =
        !["audit", "clientInfo"].includes(activeTab) &&
        isShowFooterByUserRole(userRoleId) &&
        checkedIfAssignedToIt();

    // #################### footer end ####################

    //  #################Actions Start#######################

    const onDeleteDossier = useCallback(async () => {
        if (dossierDetails?.id) {
            const deletingDossierRes = await deleteDossier(dossierDetails.id);
            if (!deletingDossierRes.detail) {
                updateModal({
                    content: (
                        <SucessDeleteDossierContent
                            onSucessDeleteDossier={() => {
                                updateContent(<Dossiers />);
                                updateIsCustomModalActive(false);
                            }}
                        />
                    ),
                    title: "",
                    disableBackdropClick: true,
                });
            }
        }
    }, [dossierDetails]);

    const downloadContract = useCallback(async () => {
        await _downloadContract(dossierId, "Contrat");
    }, []);

    const _GenerateContract = useCallback(async () => {
        await generateContract(dossierId, "Contrat-généré");
    }, [dossierDetails]);

    // ******************** Contract manager
    const onManageContract = useCallback(
        async (file: any) => {
            const contractUploaded = await uploadContractService({
                dossier_id: dossierId,
                file,
            });
            if (!contractUploaded.detail) {
                await fetchDossierDetail(dossierId);
                updateIsCustomModalActive(false);
            }
        },
        [dossierDetails]
    );

    const manageContract = useCallback(() => {
        updateModal({
            content: (
                <ContractManagerModalContent
                    onFinished={onManageContract}
                    downloadContract={downloadContract}
                    contractSignedUrl={contractSignedUrl}
                    generateContract={_GenerateContract}
                />
            ),
            title: "",
        });
        updateIsCustomModalActive(true);
    }, [dossierDetails]);

    // ******************** Contract manager

    const toBulkAssignedDossier = useCallback(
        async (dossierIdsToAssign: number[], instructeurId: number) => {
            fetcher(
                (async () => {
                    const assignmentDossierRes = await dossiersAssignment(
                        dossierIdsToAssign,
                        instructeurId
                    );
                    if (!assignmentDossierRes.detail) {
                        await fetchDossierDetail(dossierId);
                        return assignmentDossierRes;
                    }
                })()
            );
        },
        [dossierDetails]
    );

    const onInstructorAssignChange = useCallback(
        async (instructeurId: number) => {
            await toBulkAssignedDossier([dossierId], instructeurId);
        },
        [dossierDetails]
    );

    const downloadAllDoc = useCallback(async () => {
        await downloadZip(dossierId);
    }, [dossierId]);

    const handlePayment = useCallback(async () => {
        if (dossierId) {
            const payment = !isPayed;
            const updatingDossierRes = await updateDossier(dossierId, {
                payment,
            });
            if (!updatingDossierRes.detail) {
                // handle when updating dossier status
            }

            setIsPayed(payment);
        }
    }, [isPayed]);

    //  #################Actions End#######################

    const showDownloadCertificateBtn = dossierDetails
        ? canShowDownloadCertificateBtn(dossierDetails, establishmentStatus)
        : false;

    const region = regionList.find(
        (r: EstablishmentCategory) => r.id === establishment?.region
    );

    const establishementsGroupsGroupedById = groupBy(
        establishmentGroups,
        (e: EstablishmentCategory) => e.id
    );

    const getGroupById = (groupId: number): EstablishmentCategory | null => {
        if (
            establishementsGroupsGroupedById &&
            establishementsGroupsGroupedById[groupId]
        ) {
            return establishementsGroupsGroupedById[groupId][0];
        }
        return null;
    };

    const establishmentGroup = getGroupById(
        Number(establishment?.establishmentGroup)
    );

    const institutionalAffiliation = {
        network: establishmentGroup ? establishmentGroup.name : "",
        region: region ? region.name : "",
    };

    useEffect(() => {
        fetchDossierDetail(dossierId);
        scrollToTop();
    }, [fetchDossierDetail, dossierId]);

    useEffect(() => {
        getAllEstablishementStatuses();
    }, []);

    useEffect(() => {
        if (dossierDetails) {
            setIsPayed(
                dossierDetails?.payment ? dossierDetails?.payment : false
            );
        }
    }, [dossierDetails]);

    useEffect(() => {
        fetchRegionList();
    }, [fetchRegionList, dossierId]);

    return (
        <>
            <header className="dossier-header">
                {dossierDetails ? (
                    <DossierHeader
                        userRoleId={userRoleId}
                        back={() => updateContent(<Dossiers />)}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        tabsMenu={tabsMenu}
                        headerInfo={headerInfos}
                        deleteDossier={() => {
                            updateModal({
                                content: (
                                    <DeleteDossierModalContent
                                        onDeleteDossier={onDeleteDossier}
                                    />
                                ),
                                title: "",
                            });
                            updateIsCustomModalActive(true);
                        }}
                        downloadCertificate={downloadCertificate}
                        onInstructorAssignChange={onInstructorAssignChange}
                        canShowDeleteBtn={canShowDeleteBtn}
                        downloadAllDoc={downloadAllDoc}
                        showDownloadCertificateBtn={showDownloadCertificateBtn}
                        downloadContract={downloadContract}
                        manageContract={manageContract}
                        onPaymentClick={handlePayment}
                        isPayed={isPayed}
                        institutionalAffiliation={institutionalAffiliation}
                    />
                ) : null}
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",

                        width: "100%",
                        "@media (max-width:1024px)": {
                            width: "100vh",
                            marginBottom: "4.5rem",
                        },
                        "@media (min-width: 600px) and (max-width:1024px)": {
                            width: "100vw",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "3rem",
                            marginLeft: "6rem",
                            marginRight: "6rem",
                            marginTop: "2rem",
                            marginBottom: "3.5rem",

                            "@media (max-width:1024px)": {
                                marginRight: "1.5rem",
                                marginLeft: "1.5rem",
                                //width: "100vh",
                            },
                        }}
                    >
                        {activeTab === "eng" && dossierDetails ? (
                            <Commitements
                                dossierInfos={{
                                    id: dossierDetails.id,
                                    year: dossierDetails.referenciel.year,
                                    establishmentType:
                                        establishment?.establishmentType,
                                    isResendToInstruct,
                                    currentDossierStatusId:
                                        dossierDetails?.dossierStatus.id,
                                    currentAssignedUserId:
                                        dossierDetails?.assignedUser,
                                }}
                                linearProgressValue={linearProgressValue}
                                commitements={
                                    dossierDetails.referenciel.commitments
                                }
                            />
                        ) : null}
                        {activeTab === "audit" && dossierDetails ? (
                            <Audit
                                dossierId={dossierDetails.id}
                                establishment={establishment}
                            />
                        ) : null}
                        {activeTab === "clientInfo" && dossierDetails ? (
                            <EstablishmentInfosView
                                establishement={
                                    dossierDetails?.establishment?.id
                                        ? dossierDetails?.establishment?.id
                                        : establishment?.id
                                        ? establishment.id
                                        : null
                                }
                                establishementOwnerId={
                                    dossierDetails.creatorUser
                                }
                            />
                        ) : null}
                    </Box>
                    {showFooter && dossierDetails ? (
                        <Footer
                            {...getFooterPropsByUserRole(userRoleId)}
                            disabledBtn={disabledFooterBtn}
                        />
                    ) : null}
                </Box>
            </main>
        </>
    );
}
